import { memo } from 'react';

import { useBalanceReportContext } from 'pages/Finance/BalanceReport/context/BalanceReportContext';
import { useRecordContext } from 'react-admin';
import { AccountAmountDataType, AmountDataType } from 'types/embedded/balanceReport';
import { formatCurrency } from 'utils/formatCurrency';

import { BalanceRow } from './BalanceReportDatagrid';
import { BalanceReportDatagridAmountDataField } from './BalanceReportDatagridAmountField';

type NumericKeys<T> = { [K in keyof T]: T[K] extends number ? K : never }[keyof T];

type Props = {
  cellClassName: string;
  color: string;
  convertedSource: NumericKeys<AmountDataType>;
  headerClassName: string;
  isOriginalAlwaysVisible?: boolean;
  label: string;
  originalSource: NumericKeys<AccountAmountDataType>;
};

const BalanceReportDatagridAmountCellComponent: React.FC<Props> = ({
  color,
  convertedSource,
  isOriginalAlwaysVisible = false,
  originalSource,
}) => {
  const record = useRecordContext<BalanceRow>();
  const { filters } = useBalanceReportContext();

  if (!record || !filters?.currency) {
    return null;
  }

  const amountData = record.amountData as AccountAmountDataType;
  const isOriginalVisible = isOriginalAlwaysVisible || record.type === 'account';

  return (
    <BalanceReportDatagridAmountDataField
      color={color}
      convertedCurrency={filters.currency}
      convertedValue={formatCurrency(amountData?.[convertedSource])}
      originalCurrency={record.currencyCode || amountData?.endPeriodBalanceCurrencyCode}
      originalValue={isOriginalVisible && formatCurrency(amountData?.[originalSource])}
    />
  );
};

export const BalanceReportDatagridAmountCell = memo(BalanceReportDatagridAmountCellComponent);
